/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseOrderRecency } from '../../models/api-response-order-recency';

export interface GetOrderRecency$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  referenceDate?: string;
}

export function getOrderRecency(http: HttpClient, rootUrl: string, params: GetOrderRecency$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOrderRecency>> {
  const rb = new RequestBuilder(rootUrl, getOrderRecency.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.query('referenceDate', params.referenceDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseOrderRecency>;
    })
  );
}

getOrderRecency.PATH = '/v1/api/ui/reporting/order-recency';
